"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@gin-betting/core");
function handleCreateBetsFail(state, action) {
    var args = action.payload.args;
    if (!args) {
        return state;
    }
    var betslipBetId = args.betslipBetId, betslipOddIdsFromArgs = args.betslipOddIds;
    var nextBetslipOdds = state.betslipOdds, nextBetslipBets = state.betslipBets;
    var betslipBet = nextBetslipBets.get(betslipBetId);
    if (!betslipBet)
        return state;
    var nextBetslipOddIds = betslipBet.betslipOddIds;
    betslipOddIdsFromArgs.forEach(function (betslipOddId) {
        var betslipOdd = nextBetslipOdds.get(betslipOddId);
        if (!betslipOdd) {
            nextBetslipOddIds = nextBetslipOddIds.delete(betslipOddId);
        }
        else {
            var nextBetslipOdd = __assign(__assign({}, betslipOdd), { singleStatus: core_1.App.BetslipStatus.ERROR });
            nextBetslipOdds = nextBetslipOdds.set(nextBetslipOdd.id, nextBetslipOdd);
        }
    });
    var nextBetslipBet = __assign(__assign({}, betslipBet), { betslipOddIds: nextBetslipOddIds });
    nextBetslipBets = nextBetslipBets.set(nextBetslipBet.id, nextBetslipBet);
    return state
        .set('betslipOdds', nextBetslipOdds)
        .set('betslipBets', nextBetslipBets);
}
exports.default = handleCreateBetsFail;
//# sourceMappingURL=handleCreateBetsFail.js.map